<form>
  <div class="card card-accent-primary shadowed">
    <div class="card-header">
      <strong> {{visuals.selectDbt}}</strong>
    </div>
    <div class="card-block">
      <div class="form-group">
        <div class="col-md-12 input-group">
          <input
            type="number"
            [formControl]="debtorForm.controls['debtorId']"
            class="form-control"
            id="debtorId"
            name="debtorId"
          />
          <basesearchmodal
            [type]="'debtorModal'"
            (valueChange)="valueChanged('debtorModal',$event)"
          ></basesearchmodal>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <button type="submit" class="btn btn-success" data-dismiss="modal" (click)="search()">
        Search
      </button>
    </div>
  </div>
</form>
<div *ngIf="loading" class="dataLoader"></div>

<div class="card card-accent-primary shadowed" *ngIf="loadingDone">
  <form [formGroup]="emailForm" (ngSubmit)="save(emailForm.value)" *ngIf="!isEditing">
    <div class="card-header">
      <strong>Email Template</strong>
    </div>
    <div class="row">
      <div class="col-md-3" *ngIf="enableBuyerImgFeature">
        <div class="column">
          <label class="hoverable" for="fileInput">
            <img
              *ngIf="emailForm.controls.invLogo.value"
              [src]="imageSrc"
              alt="alt text"
              style="text-align: center;"
            />
            <div class="hover-text" *ngIf="!emailForm.controls.invLogo.value">
              <i *ngIf="!emailForm.controls.invLogo.value" class="mdi mdi-upload md-32 "></i>
              Choose Image
            </div>
            <div class="background"></div>
          </label>
          <input
            id="fileInput"
            name="invLogo"
            type="file"
            accept="image/*"
            (change)="handleInputChange($event)"
          />
          <input type="hidden" name="fileHidden" formControlName="invLogo" />
          <div class="error">{{error}}</div>
        </div>
        <div style="margin-bottom: 20px;" class="text-center">
          <button (click)="clearImage()" type="button" class="btn btn-primary">Clear Image</button>
        </div>
      </div>
      <div [ngClass]="{'col-md-9': enableBuyerImgFeature, 'col-md-12':!enableBuyerImgFeature }">
        <div [innerHTML]="content | safeHtml"></div>
      </div>
    </div>
    <div class="card-footer text-center" *ngIf="!viewRole && enableBuyerImgFeature">
      <button type="submit" class="btn btn-success">Save</button>
    </div>
  </form>
  <div *ngIf="isEditing" class="dataLoader"></div>
</div>
